const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'Keine Datei ausgewählt',
    fileName: 'Dateiname',
    software_service: 'Software-Service',
    hardware_product: 'Hardware-Produkt',
    sampleFileNameUs: 'Warenkredit USA',
    sampleFileNameAu: 'Warenkredit AU',
    rowNumber: 'Zeilennummer',
    errorMessage: 'Nachricht'
  }
};

export default merchandiseCredit;
